// @flow

import React, { useEffect } from 'react';
import Helmet from 'react-helmet';
import { BrowserSupport } from '@latitude/browser-support';
import { Footer } from '@latitude/footer';
import KiwibankHeader from './Header/KiwibankHeader';
import footerData from '../data/json/footer.json';
import '../../sass/style.scss';

type Props = {
  children: React.Node,
  // Optional Header display
  noHeader?: boolean,
  // Optional Footer display
  noFooter?: boolean
};

function Layout(props: Props) {

  useEffect(() => {
    if (typeof window !== 'undefined') {
      if (window.location.hostname === "kiwibank.latitudefinancial.com") {
        window.location.replace("https://www.gemfinance.co.nz/");
      }
    }
  }, []);

  return (
    <>
      <Helmet>
        <meta name="apple-mobile-web-app-capable" content="yes" />
        <meta name="format-detection" content="telephone=no" />
        <link rel="shortcut icon" type="image/x-icon" href="/favicon.ico" />

        {/* <!-- Google Fonts --> */}
        <link
          href="https://fonts.googleapis.com/css?family=Roboto+Slab:400,700|Roboto:300,400,500,700"
          rel="stylesheet"
        />
        <link
          href="https://fonts.googleapis.com/css?family=Montserrat:400,800,600&display=swap"
          rel="stylesheet"
        />

        <script
          type="text/javascript"
          src="https://www.bugherd.com/sidebarv2.js?apikey=k8x4tdkkpaylbl47h1vpyq"
          async="true"
        />
      </Helmet>

      <BrowserSupport />

      {!props.noHeader && <KiwibankHeader />}

      {props.children}

      {!props.noFooter && (
        <Footer
          socialLinks={footerData.socialLinks}
          siteLinks={footerData.siteLinks}
          appLinks={footerData.appLinks}
          footerLinks={footerData.footerLinks}
          finePrint={footerData.finePrint}
          isNz
        />
      )}
    </>
  );
};

export default Layout;